/**
 * AutoScale extended simple units that auto-scale is supported for.
 */ var reAutoUnit = /^auto-((?:kilo|mega|giga|tera)?(?:bit|byte)|(?:(?:[kg]i|[mtp]e)?bi|peta)byte|(?:kilo)?gram|(?:ounce|pound|stone)|(?:centi|milli|kilo)?meter|(?:inch|foot|yard|mile)|(?:milli)?liter|(?:(?:milli)?second|minute|hour|day|week|month|year))(-per-[a-z]+(?:-[a-z]+)?|)$/;
export var isNumberAutoScaleFormatAutoUnit = function isNumberAutoScaleFormatAutoUnit(unit) {
    return typeof unit === 'string' && reAutoUnit.test(unit);
};
export var parseNumberAutoScaleFormatAutoUnit = reAutoUnit.exec.bind(reAutoUnit);

//# sourceMappingURL=NumberAutoScaleFormatApi.js.map